import { createBrowserRouter, Outlet } from 'react-router';
import { LayoutMain } from '../containers';
import { routesAuth } from './routesAuth';
import { routesMain } from './routesMain';
import { QueryBoundary } from '@outdoria/ui';

const entries = [
  {
    path: '/auth',
    element: (
      <QueryBoundary>
        <Outlet />
      </QueryBoundary>
    ),
    children: routesAuth,
  },
  {
    path: '/',
    element: <LayoutMain />,
    children: routesMain,
  },
];

export const router = createBrowserRouter(entries);
